import React from "react";
import { DisabledPrompt } from "bcms-react";
import { TableItemContainer, TableItemTextView, TableItemView } from "components/shared";
import { UICheckbox } from "components/ui";
import { SVGAsset } from "res";

/**
 * @function StateTaxIDTableRow
 * @param {STRING} company - Sets the company name text.
 * @param {STRING} state - Sets the company state text.
 * @param {STRING} taxId - Sets the compony tax ID text.
 * @return {React.Component}
 * @exported true
 * @description This is the State tax ID table row used for the main table view.
 */
export default function StateTaxIDTableRow(props) {
  const stateTaxID = props.stateTaxID ?? {};
  const company = props.company ?? "[company]";
  const state = props.state ?? "[state]";
  const taxId = props.taxId ?? "[taxId]";
  const onRowClick = props.onRowClick ?? (() => {});
  const isSelected = props.isSelected === "true";
  const dataPointCheckbox = { "dataPoint" : `State_Tax_ID_Checkbox_${ stateTaxID.id }` };
  const dataPointCompany = { "dataPoint" : `State_Tax_ID_Company_${ stateTaxID.id }` };
  const dataPointState = { "dataPoint" : `State_Tax_ID_State_${ stateTaxID.id }` };
  const dataPointTaxID = { "dataPoint" : `State_Tax_ID_Tax_ID_${ stateTaxID.id }` };

  return (
    <TableItemContainer>
      <TableItemView className="checkbox-col">
        <UICheckbox label="" { ...dataPointCheckbox } value={ isSelected } onChange={ onRowClick(stateTaxID) } />
      </TableItemView>
      <TableItemTextView className="company-col" { ...dataPointCompany } text={company} />
      <TableItemTextView className="state-col" { ...dataPointState } text={state} />
      <TableItemTextView className="tax-id-col" { ...dataPointTaxID } text={taxId} />
      <TableItemView className="actions-col text-right">
        <DisabledPrompt>
          <SVGAsset id="PencilIcon" className="pencil-icon clickable" />
        </DisabledPrompt>

        <DisabledPrompt>
          <SVGAsset id="TrashcanXIcon" className="trash-can-x-icon clickable"/>
        </DisabledPrompt>

      </TableItemView>
    </TableItemContainer>

  )
}
